import React, { useContext } from "react";
import { Language } from "../../../App";

export function SessionStatus({ paymentStatus }) {
  const { lang } = useContext(Language) || {};
  const isSuccess = paymentStatus === "paid";

  let message = lang?.payment_status_processing || "Payment status is being processed.";
  if (isSuccess) {
    message = lang?.payment_successful_thanks || "Payment successful! Thank you for your purchase.";
  } else if (paymentStatus) {
    const statusStr = paymentStatus ?? (lang?.unknown || "unknown");
    message = (lang?.payment_status_with_paypal_desc || "Payment status: {status}. Please complete your purchase using PayPal.")
      .replace("{status}", statusStr);
  } else {
    message = lang?.payment_not_completed_paypal_desc || "Payment was not completed. Please complete your purchase using PayPal.";
  }

  const alertClass = isSuccess ? "alert-success" : "alert-danger";

  return (
    <div className={`alert ${alertClass} mt-3`} role="alert">
      <p className="mb-1">
        <strong>{lang?.payment_status_label || "Payment status:"}</strong> {paymentStatus ?? (lang?.unknown || "unknown")}
      </p>
      <p className="mb-0">{message}</p>
    </div>
  );
}

export default SessionStatus;
